import React, { Component, Fragment } from 'react'
import { Col, Form, InputNumber, Popconfirm, Row, Select, Table } from 'antd'
import moment from 'moment'
import { get } from 'lodash'
import Dropdowns from '../../../../../../../api/Dropdowns'
import CurrencySelect from '../../../../../../../elements/Select/Currency'
import PayPeriodSelect from '../../../../../../../elements/Select/Employee/PayPeriod'
import RequisitionsSelect from '../../../../../../../elements/Select/Employee/Requisitions'
import NumberColumn from '../../../../../../../elements/Table/Columns/Number'
import { sessionItemVal } from '../../../../../../../modules/Utils'

const FormItem = Form.Item

class Compensation extends Component {
  uuid = moment().unix()

  dropdownApi = new Dropdowns()

  renderColumnsUom(text, record, column) {
    return (
      <div>
        {record.editable ? (
          <Select
            onChange={(value) => this.props.handleChange(value, record.key, column)}
            value={text}
            showSearch
            style={{ width: 100 }}
            placeholder="Select a Uom">
            <Select.Option value={'H'}>Hour</Select.Option>
            <Select.Option value={'DAY'}>Day</Select.Option>
          </Select>
        ) : (
          sessionItemVal('employee_uom_dropdown', text)
        )}
      </div>
    )
  }

  render() {
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 7 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    }
    const { getFieldDecorator } = this.props.form
    const { workOrder, type, fetchingRates } = this.props
    let columns = [
      {
        title: 'Name',
        dataIndex: 'name',
      },
      {
        title: 'Type',
        dataIndex: 'type',
        render: (value) => sessionItemVal('employee_valueType_dropdown', value),
      },
      {
        title: 'UoM',
        dataIndex: 'uom',
        render: (text, record) => this.renderColumnsUom(text, record, 'uom'),
      },
      {
        title: 'Rate',
        dataIndex: 'rate',
        render: (value, original) => (
          <NumberColumn
            onChange={this.props.handleChange}
            value={value}
            record={original}
            dataIndex={this.props.keyAtr}
            column={'rate'}
          />
        ),
      },
      {
        title: 'Operation',
        dataIndex: 'operation',
        render: (value, original) => {
          const { editable } = original
          return (
            <div className="editable-row-operations">
              {editable ? (
                <span>
                  <a onClick={() => this.props.save(original[this.props.keyAtr])}>Save</a>
                  <span className="ant-divider" />
                  <Popconfirm title="Sure to cancel?" onConfirm={() => this.props.cancel(original[this.props.keyAtr])}>
                    <a>Cancel</a>
                  </Popconfirm>
                </span>
              ) : (
                <a onClick={() => this.props.edit(original[this.props.keyAtr])}>Edit</a>
              )}
            </div>
          )
        },
      },
    ]
    if (type === 'view') columns = columns.filter((c) => c.dataIndex !== 'operation')
    return (
      <Fragment>
        <Form layout="horizontal">
          <Row>
            <Col span={12}>
              <FormItem label="Currency" {...formItemLayout}>
                {getFieldDecorator('currency', {
                  initialValue: workOrder.currency,
                  rules: [
                    {
                      required: true,
                      message: "Currency can't be empty ",
                    },
                  ],
                })(<CurrencySelect />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Type" {...formItemLayout}>
                {getFieldDecorator('type', {
                  initialValue: workOrder.type,
                  rules: [
                    {
                      required: true,
                      message: "Type can't be empty",
                    },
                  ],
                })(<PayPeriodSelect placeholder="Type" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Requisition" {...formItemLayout}>
                {getFieldDecorator('requisition._id', {
                  initialValue: get(workOrder, 'requisition._id'),
                  rules: [
                    {
                      required: true,
                      message: "Requisition can't be empty",
                    },
                  ],
                })(<RequisitionsSelect placeholder="Requisition" />)}
              </FormItem>
            </Col>
          </Row>
          <Row style={{ paddingBottom: 10, paddingTop: 10 }}>
            <h2 style={{ color: 'rgb(43,187,143)' }}>Rates</h2>
          </Row>
          <Row>
            <Table
              loading={fetchingRates}
              pagination={false}
              columns={columns}
              dataSource={workOrder.rates}
              size="small"
              style={{ marginTop: 10 }}
            />
          </Row>
          <Row style={{ paddingBottom: '10px', paddingTop: '10px' }}>
            <h2 style={{ color: 'rgb(43,187,143)' }}>Payment</h2>
          </Row>
          <Row>
            <Col span={12}>
              <FormItem label="Period Gross Pay" {...formItemLayout}>
                {getFieldDecorator('amount.gross', {
                  initialValue: get(workOrder, 'amount.gross'),
                  rules: [
                    {
                      required: true,
                      message: "Period Gross Pay can't be empty ",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} placeholder="Rostered Day Rate" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Period Tax Pay" {...formItemLayout}>
                {getFieldDecorator('amount.tax', {
                  initialValue: get(workOrder, 'amount.tax'),
                  rules: [
                    {
                      required: true,
                      message: "Period Tax Pay can't be empty ",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} placeholder="Period Tax Pay" />)}
              </FormItem>
            </Col>
            <Col span={12}>
              <FormItem label="Period Net Pay" {...formItemLayout}>
                {getFieldDecorator('amount.net', {
                  initialValue: get(workOrder, 'amount.net'),
                  rules: [
                    {
                      required: true,
                      message: "Period Net Pay (Take Home) can't be empty ",
                    },
                  ],
                })(<InputNumber style={{ width: '100%' }} placeholder="Period Net Pay (Take Home)" />)}
              </FormItem>
            </Col>
          </Row>
        </Form>
      </Fragment>
    )
  }
}

export default Form.create()(Compensation)
